import { Component } from '@angular/core';

@Component({
  selector: 'wz-main',
  templateUrl: './main.component.html',
})
export class MainComponent { // this wrapper is needed in order to get queryparams in app.component to work
  constructor() {  }
}
